<app-user-terms></app-user-terms>
<app-bottom-menu></app-bottom-menu>